"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = void 0;
const helpers_1 = require("@/helpers");
const formatNumber = (value, decimalPlaces = 2) => {
    // Normalize input: remove thousand separators if input is a string
    const normalized = typeof value === "string"
        ? (0, helpers_1.removeThousandSeparator)(value)
        : value;
    const num = Number(normalized);
    if (isNaN(num)) {
        // Log error for debugging, return empty string for graceful fallback
        console.error("formatNumber: Invalid input", { value });
        return "";
    }
    // Format number with fixed decimals and thousand separators
    const formatted = num.toFixed(decimalPlaces);
    return (0, helpers_1.addThousandSeparator)(formatted);
};
exports.formatNumber = formatNumber;
